import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useCreateFolderMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ folderParams }) => {
      const response = await axios.post('/folders', { folder: folderParams });
      return response.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries(['folders']);
      queryClient.invalidateQueries([
        'projectsDashboards',
        'navigationOptions',
      ]);

      if (variables.folderParams.project_ids) {
        queryClient.invalidateQueries(['projectsReports', 'dashboardReports']);
      }
    },
  });
}

export function useUpdateFolderMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ folderParams, id }) => {
      const response = await axios.patch(`/folders/${id}`, {
        folder: folderParams,
      });

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['folders']);
      queryClient.invalidateQueries([
        'projectsDashboards',
        'navigationOptions',
      ]);
      queryClient.invalidateQueries(['projectsReports', 'dashboardReports']);
    },
  });
}

export function useDestroyFolderMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, params }) => {
      const response = await axios.delete(`/folders/${id}`, { params });
      return response.data;
    },
    onSuccess: async (_result, variables) => {
      await queryClient.cancelQueries({
        queryKey: ['folders', variables.id],
        exact: true,
      });

      queryClient.removeQueries({
        queryKey: ['folders', variables.id],
        exact: true,
      });

      queryClient.invalidateQueries(['folders']);
      queryClient.invalidateQueries([
        'projectsDashboards',
        'navigationOptions',
      ]);
      queryClient.invalidateQueries(['projectsReports', 'dashboardReports']);
    },
  });
}
